/** Phase 234 — Wraps sonner's toast methods with subtle haptic feedback so
 * every success/error/warning toast across the entire app gives a gentle
 * buzz on touch devices. Idempotent — safe to import multiple times. */

import { toast } from "sonner";
import { haptic } from "./haptics";

let installed = false;

export function installHapticToasts() {
  if (installed) return;
  installed = true;
  const wrap = (name, kind) => {
    const original = toast[name];
    if (typeof original !== "function") return;
    toast[name] = (...args) => {
      try { haptic(kind); } catch { /* ignore */ }
      return original.apply(toast, args);
    };
  };
  wrap("success", "success");
  wrap("error", "error");
  wrap("warning", "warning");
  wrap("info", "light");
}
